import React, { useRef, useState } from 'react';
import { useClickAway } from 'ahooks';
import { not } from 'ramda';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import ChatSVG from 'assets/images/icons/chat.svg';
import StyledDropdown from 'Common/Components/Dropdown';

const w: any = window;

const IntegrationsDropdown: React.FC = () => {
  const [showMenu, setShowMenu] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  useClickAway(() => {
    setShowMenu(false);
  }, ref);

  return (
    <div>
      <span ref={ref}>
        <StyledDropdown width="150px">
          <Button
            icon={<ChatSVG css={{ fontSize: 25 }} />}
            css={`
              margin: 17px 15px auto 15px;
              border: none;
              box-shadow: none;
            `}
            onClick={() => setShowMenu(not)}
          />
          <div className={`menu ${showMenu ? 'visible' : 'hidden'}`}>
            <button type="button">
              <a
                href="https://help.shore.com/de"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage defaultMessage="Support Center" />
              </a>
            </button>
            <button
              type="button"
              onClick={() => w.Userlane && w.Userlane('openAssistant')}
            >
              <FormattedMessage defaultMessage="Product Tour" />
            </button>
          </div>
        </StyledDropdown>
      </span>
    </div>
  );
};

export default IntegrationsDropdown;
